// Fonctions pour gérer les paramètres d'administration

// Clé pour le stockage local
const API_KEY_STORAGE_KEY = 'openai_api_key';

/**
 * Sauvegarde la clé API dans le stockage local
 */
export const saveApiKey = async (apiKey: string): Promise<void> => {
  try {
    localStorage.setItem(API_KEY_STORAGE_KEY, apiKey);
    
    // Mettre à jour la variable d'environnement (ne fonctionne pas réellement en production)
    // Cette ligne est juste pour simuler la mise à jour
    (window as any).VITE_OPENAI_API_KEY = apiKey;
    
    return Promise.resolve();
  } catch (error) {
    console.error('Erreur lors de la sauvegarde de la clé API:', error);
    return Promise.reject(new Error('Impossible de sauvegarder la clé API'));
  }
};

/**
 * Récupère la clé API depuis le stockage local
 */
export const getApiKey = async (): Promise<string | null> => {
  try {
    const apiKey = localStorage.getItem(API_KEY_STORAGE_KEY);
    return Promise.resolve(apiKey);
  } catch (error) {
    console.error('Erreur lors de la récupération de la clé API:', error);
    return Promise.reject(new Error('Impossible de récupérer la clé API'));
  }
};

/**
 * Teste la connexion à l'API OpenAI
 */
export const testApiConnection = async (
  apiKey: string,
  apiUrl: string,
  model: string,
  temperature: number,
  topP: number
): Promise<boolean> => {
  try {
    // Requête de test simple
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        messages: [
          { role: 'system', content: 'You are a helpful assistant.' },
          { role: 'user', content: 'Hello, this is a test message.' }
        ],
        model: model,
        temperature: temperature,
        top_p: topP,
        stream: false
      })
    });

    if (!response.ok) {
      throw new Error(`Erreur API: ${response.status}`);
    }

    const data = await response.json();
    
    // Vérifier que la réponse contient les données attendues
    if (!data || !data.choices || !data.choices[0]?.message?.content) {
      throw new Error('Format de réponse invalide');
    }

    return true;
  } catch (error) {
    console.error('Erreur lors du test de connexion:', error);
    throw error;
  }
};